import React, { useEffect } from "react"
import { MapContainer, Marker, Popup, TileLayer, LayersControl } from "react-leaflet";
import MarkerIcon from '../../assets/images/marker-icon.png';
import L from 'leaflet';
import { stringToHslColor, getDarkerHslColor } from '../../helper/extension';
import 'leaflet/dist/leaflet.css';

// Define a custom icon
const customIcon = L.icon({
    iconUrl: MarkerIcon, // Provide the path to your custom icon image
    iconSize: [32, 32], // Size of the icon
    iconAnchor: [16, 32], // Point of the icon which will correspond to marker's location
    popupAnchor: [0, -32], // Point from which the popup should open relative to the iconAnchor
});

const Map = ({ position, doctors, isSearchResult, hoveredItem }) => {

    return (
        <>
            {isSearchResult && doctors?.length > 0 ? (
                <MapContainer
                    center={[doctors[0].doctorInfo.latitude, doctors[0].doctorInfo.longitude]}
                    zoom={13}
                    scrollWheelZoom={true}
                    style={{ height: '300px', width: '100%', borderRadius: '18px' }}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                    />
                    {doctors?.map((doctor, index) =>
                        doctor?.doctorInfo &&
                        doctor?.doctorInfo?.latitude && doctor?.doctorInfo?.longitude && (
                            <Marker
                                key={`${doctor?.doctorInfo?.fkUserId}-${index}`}
                                position={[doctor?.doctorInfo?.latitude, doctor?.doctorInfo?.longitude]}
                                icon={
                                    doctor?.doctorInfo?.photo
                                        ? new L.Icon({
                                            iconUrl: doctor?.doctorInfo?.photo,
                                            iconSize: [60, 60], // Adjust size
                                            className:
                                                hoveredItem === index
                                                    ? 'custom-icon fallback-icon-zoom'
                                                    : 'custom-icon', // Styling
                                        })
                                        : new L.DivIcon({
                                            html: `
                                                <div class="${hoveredItem === index ? 'fallback-icon fallback-icon-zoom' : 'fallback-icon'}"
                                                    style="background-color: ${stringToHslColor(
                                                doctor?.doctorInfo?.firstName?.charAt(0) + doctor?.doctorInfo?.lastName?.charAt(0)
                                            )}; border: 2px solid ${getDarkerHslColor(
                                                doctor?.doctorInfo?.firstName?.charAt(0) + doctor?.doctorInfo?.lastName?.charAt(0)
                                            )};">
                                                    ${doctor?.doctorInfo?.firstName?.charAt(0)}${doctor?.doctorInfo?.lastName?.charAt(0)}
                                                </div>`,
                                            className: 'fallback-icon-container',
                                            iconSize: [60, 60],
                                        })
                                }
                            >
                                <Popup closeButton={false}>
                                    <strong>
                                        {doctor?.doctorInfo?.firstName} {doctor?.doctorInfo?.lastName}
                                    </strong>
                                    <br />
                                    Specialty: {doctor?.doctorInfo?.specialtyName}
                                    <br />
                                    Credential: {doctor?.doctorInfo?.credential}
                                    <br />
                                    Organization: {doctor?.doctorInfo?.organizationName}
                                    <br />
                                    Avg Review: {doctor?.doctorInfo?.overAllAvgReview}{' '}
                                    {doctor?.doctorInfo?.overAllAvgReview !== 0 ? '⭐' : ''}
                                </Popup>
                            </Marker>
                        )
                    )}
                </MapContainer>
            ) : (
                <>
                    <MapContainer center={position} zoom={13} scrollWheelZoom={true} style={{ height: '300px', width: '100%', borderRadius: '18px' }}>
                        {/* <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        /> */}
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                        />
                        <Marker position={position} icon={customIcon}>
                            <Popup>
                                A pretty CSS3 popup. <br /> Easily customizable.
                            </Popup>
                        </Marker>
                    </MapContainer>
                </>
            )}
        </>
    )
};

export default Map;

